import { Controller } from 'stimulus';
import moment from 'moment';

export default class extends Controller {
  static targets = ['links', 'periodTitle', 'beginsOn', 'endsOn',
  'form', 'presenter', 'date'];

  connect() {
    this.beginsOn = this.beginsOnTarget.value;
    this.endsOn = this.endsOnTarget.value;
    if (this.beginsOn || this.endsOn) this._updatePeriodTitle();
    this._renderDateInPresenter();
  }

  toggleTimeRangeStates(e) {
    const type = e.target.dataset.type;
    let states = this.element.querySelectorAll(`.schedules-timerange-${type}-button`);
    let memoizeDay = "init";

    if (type === 'openH24') {
      states = [...this.element.querySelectorAll('.schedules-timerange-open-button')];
      [...states].forEach(state => {
        state.click();
        this._fillAllTimerangeWithH24(state.dataset.weekday);
      });
      [...this.element.querySelectorAll('.h24 input')].forEach((checkbox) => checkbox.click());
    } else {
       [...states].forEach(state => {
         const actualCheckedInput = [...state.parentNode.querySelectorAll('input')].find((item) => item.value === type);
         if (!actualCheckedInput.checked && memoizeDay !== state.dataset.weekday) state.click();
         memoizeDay = state.dataset.weekday;
       });
    }
  }

  handleBeginsOnChange(e) {
    this.beginsOn = e.currentTarget.value;
    this._updatePeriodTitle();
    this._updateDaysVisibility();
  }

  handleEndsOnChange(e) {
    this.endsOn = e.currentTarget.value;
    this._updatePeriodTitle();
    this._updateDaysVisibility();
  }

  toggleForm(e) {
    const show = e.target.dataset.toggleType === "show";
    this.presenterTarget.classList.toggle('d-none', show);
    this.formTarget.classList.toggle('d-none', !show);
  }

  // PRIVATE

  _fillAllTimerangeWithH24(weekday) {
    const timeInputs = [...this.element.querySelectorAll('.time-inputs')].filter((item) => {
      return item.dataset.weekday === weekday && !item.classList.contains('d-none');
    });

    [...timeInputs].forEach((item) => {
      this._closeAllTimeranges(weekday, item);
    });

    const timeranges = [...this.element.querySelectorAll('.time-range-row')].filter((item) => {
      return !item.classList.contains('d-none');
    });

    [...timeranges].forEach((item) => {
      [...item.querySelectorAll('.add-range-container .btn')]
              .forEach((item) => item.classList.add('d-none'));
    });
  }

  _hidePickers(timeInputs) {
    [...timeInputs].forEach((item) => item.classList.add('d-none'));
  }

  _closeAllTimeranges(weekday, item) {
    const loopOverRows = setInterval(() => {
      const rows = this._getVisibleRow(weekday);

      if (rows.length > 1) {
        const clickableRow = rows.find((item) => item.querySelector('.fa-xmark'));
        clickableRow.querySelector('.fa-xmark').dispatchEvent(new Event('click'));
      } else {
        if (item) {
          this._setPickersValueToH24([...item.querySelectorAll('.schedules-time-input')]);
          this._hidePickers([...item.querySelectorAll('.time-range-row')]);
          item.classList.add('d-none');
        }
        clearInterval(loopOverRows);
      };
    });
  }

  _getVisibleRow(weekday) {
    const timeranges = [...this.element.querySelectorAll('.time-range-row')]
      .filter((row) => row.dataset.weekday === weekday && !row.classList.contains('d-none'));

    return timeranges.filter((tr) => !tr.querySelector('.time-inputs')?.classList.contains('d-none'))
                      .filter((item) => item.querySelector('.fa-xmark'));
  }

  _setPickersValueToH24(domElements) {
    [...domElements].forEach((item) => {
      if (item.id.includes('begin_time')) {
        item.value = '00:00';
        item.nextElementSibling.value = '00:00';
        item.nextElementSibling.placeholder = '00:00';
      }

      if (item.id.includes('end_time')) {
        item.value = '23:59';
        item.nextElementSibling.value = '23:59';
        item.nextElementSibling.placeholder = '23:59';
      }
    });
  }

  _renderDateInPresenter() {
    this.dateTarget.innerHTML = this.periodTitleTarget.innerHTML;
  }

  _formatDate(date) {
    return moment(date).format('DD/MM/YYYY');
  }

  _updatePeriodTitle() {
    if (this.beginsOn && this.endsOn) {
      this.periodTitleTarget.innerHTML = `Du ${this._formatDate(this.beginsOn)} au ${this._formatDate(this.endsOn)}`;
    } else if (this.beginsOn) {
      this.periodTitleTarget.innerHTML = `À partir du ${this._formatDate(this.beginsOn)}`;
    } else if (this.endsOn) {
      this.periodTitleTarget.innerHTML = `Jusqu'au ${this._formatDate(this.endsOn)}`;
    } else {
      this.periodTitleTarget.innerHTML = 'Nouvelle période';
    }
  }

  _resetDaysRowsClass() {
    [...this.element.querySelectorAll('.time-range-row')].forEach((item) => {
      item.classList.remove('d-none');
    });
  }

  _updateDaysVisibility() {
    const start = this.beginsOn ? moment(this.beginsOn).startOf('day') : moment().subtract(200, 'years');
    const end = this.endsOn ? moment(this.endsOn) : moment().add(200, 'years');
    const isValidPeriodRange = end.diff(start) >= 0;

    if (isValidPeriodRange) this._showAllDays();

    if (this.beginsOn && this.endsOn) {
      this._resetDaysRowsClass();

      const timeRangesRows = [...this.element.querySelectorAll('.time-range-row')];

      if (isValidPeriodRange) {
        const numberOfDaysInSelectedRange = moment.duration(end.diff(start)).asDays();
        if (numberOfDaysInSelectedRange < 7) {
          const days = [...Array(numberOfDaysInSelectedRange + 1).keys()]
            .map(i => start.clone().add(i, 'd').format('dddd'));

          timeRangesRows.forEach((i) => {
            if (!days.map((day) => day.toLowerCase()).includes(i.dataset.weekday)) {
              i.classList.add('d-none');
            }
          });
        }
      } else {
        timeRangesRows.forEach((i) => i.classList.add('d-none'));
      }
    }
  }

  _showAllDays() {
    this.element.querySelector('.schedules-buttons').classList.remove('d-none');
    [...this.element.querySelectorAll('.time-range-row')].forEach((i) => i.classList.remove('d-none'));
  }
}
